import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Users, Shield, Building2, ArrowRight, Sparkles } from "lucide-react";

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4 overflow-hidden relative">
      {/* Animated background orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute -top-40 -right-40 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse"
        />
        <div 
          className="absolute -bottom-40 -left-40 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "1s" }}
        />
        <div 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-emerald-500/10 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "2s" }}
        />
      </div>

      {/* Grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: "50px 50px",
        }}
      />

      {/* Main content */}
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Logo */}
        <div className="mb-8 inline-flex items-center justify-center">
          <div 
            className="w-24 h-24 rounded-3xl flex items-center justify-center relative overflow-hidden"
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
            }}
          >
            <Users className="w-12 h-12 text-white" strokeWidth={1.5} />
            
            {/* Floating badge */}
            <div 
              className="absolute -top-2 -right-2 w-8 h-8 rounded-lg flex items-center justify-center"
              style={{
                background: "rgba(59, 130, 246, 0.4)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(59, 130, 246, 0.5)",
              }}
            >
              <Sparkles className="w-4 h-4 text-blue-300" />
            </div>
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
          Admin Panel
        </h1>
        <p className="text-xl md:text-2xl text-white/60 mb-8">
          Gestión de Usuarios y Empresas
        </p>

        {/* Feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          <div 
            className="p-6 rounded-2xl text-left"
            style={{
              background: "rgba(255, 255, 255, 0.05)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center mb-4">
              <Shield className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Propietarios</h3>
            <p className="text-sm text-white/50">
              Gestiona propietarios con múltiples empresas y sucursales
            </p>
          </div>

          <div 
            className="p-6 rounded-2xl text-left"
            style={{
              background: "rgba(255, 255, 255, 0.05)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center mb-4">
              <Users className="w-6 h-6 text-emerald-400" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Empleados</h3>
            <p className="text-sm text-white/50">
              Administra empleados asignados a empresas específicas
            </p>
          </div>

          <div 
            className="p-6 rounded-2xl text-left"
            style={{
              background: "rgba(255, 255, 255, 0.05)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <div className="w-12 h-12 rounded-xl bg-purple-500/20 flex items-center justify-center mb-4">
              <Building2 className="w-6 h-6 text-purple-400" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Empresas</h3>
            <p className="text-sm text-white/50">
              Organiza empresas con sus respectivas sucursales
            </p>
          </div>
        </div>

        {/* CTA Button */}
        <Link href="/dashboard">
          <Button 
            size="lg" 
            className="gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-xl shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40 transition-all duration-300 hover:scale-105"
          >
            Ingresar al Panel
            <ArrowRight className="w-5 h-5" />
          </Button>
        </Link>

        {/* Footer text */}
        <p className="mt-8 text-sm text-white/30">
          Almacenamiento local • Sin conexión a internet requerida
        </p>
      </div>
    </div>
  );
}
